import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { PARTNER_FORM_FIELDS, PARTNER_FORM_FIELDS_NAMES } from './new-partner-form';
export const PARTNER_INFORMATION_INPUTS = ({ t, lists, partnerData }): IFormInputProps[] => [
	{
		key: PARTNER_FORM_FIELDS.PARTNER_NAME,
		fieldName: PARTNER_FORM_FIELDS.PARTNER_NAME,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.PARTNER_NAME)}`,
		label: t(PARTNER_FORM_FIELDS_NAMES.PARTNER_NAME),
		inputType: InputType.Text,
		required: true,
		additionalClasses: 'col-12',
		fakeInputAdditionalClass: 'col-12',
		autoComplete: 'off'
	},
	{
		key: PARTNER_FORM_FIELDS.PARTNER_TYPE,
		fieldName: PARTNER_FORM_FIELDS.PARTNER_TYPE,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.PARTNER_TYPE)}`,
		label: t(PARTNER_FORM_FIELDS_NAMES.PARTNER_TYPE),
		inputType: InputType.Select,
		data: lists?.partnerTypes,
		searchable: false,
		cleanable: false,
		disabled: partnerData?.[PARTNER_FORM_FIELDS.PARTNER_TYPE],
		additionalClasses: 'col-12',
		fakeInputAdditionalClass: 'col-12',
		autoComplete: 'off'
	},
];
